export enum AccessAccountsApiPath {
  GET_ACCESS_ACCOUNTS = 'irent/ConnectedAccessAccount',
  GET_ACCESS_ACCOUNT_LOCKS = 'irent/ConnectedAccessAccount',
  CREATE_ACCESS_ACCOUNT = 'irent/ConnectedAccessAccount',
}
